import React from 'react'
import { Container, TextField, SelectField, RangeField } from '../Fields'
import { odometerOptions, photosOptions, yearOptions, yesNoOptions } from './selectOptions'

export const VehicleView: React.VFC = () => {
    return (
        <Container>
            <TextField label="Has The Words" name="filters.hasWords" placeholder="Try any search term" />
            <TextField label="Make" name="filters.vehicle.make" placeholder="Try 'Ford' or 'Ford, Kia'" />
            <TextField label="Model" name="filters.vehicle.model" placeholder="Try 'F-150'" />
            <TextField label="Color" name="filters.vehicle.color" placeholder="Try 'Gray' or 'Gray, Red'" />
            <TextField label="Check-In Offset" name="filters.vehicle.checkIn" placeholder="Try '5' or '5+'" />
            <RangeField
                label="Year"
                selectProps={{ name: 'filters.vehicle.year', options: yearOptions }}
                lowProps={{
                    name: 'filters.vehicle.yearLow',
                    placeholder: "Try '2010'",
                    thousandSeparator: false,
                    rules: { validate: (val) => !val || (+val > 1900 && +val < 2100) },
                }}
                highProps={{
                    name: 'filters.vehicle.yearHigh',
                    placeholder: "Try '2020'",
                    thousandSeparator: false,
                    rules: { validate: (val) => !val || (+val > 1900 && +val < 2100) },
                }}
            />
            <RangeField
                label="Odometer"
                selectProps={{
                    name: 'filters.vehicle.odo',
                    options: odometerOptions,
                }}
                lowProps={{
                    name: 'filters.vehicle.odoLow',
                    placeholder: "Try '10000'",
                    rules: { validate: (val) => !val || +val >= 10_000 },
                }}
                highProps={{
                    name: 'filters.vehicle.odoHigh',
                    placeholder: "Try '90000'",
                    rules: { validate: (val) => !val || +val >= 10_000 },
                }}
            />
            <RangeField
                label="Photo Count"
                selectProps={{
                    name: 'filters.vehicle.photos',
                    options: photosOptions,
                }}
                lowProps={{ name: 'filters.vehicle.photosLow', placeholder: "Try '1'" }}
                highProps={{
                    name: 'filters.vehicle.photosHigh',
                    placeholder: "Try '10'",
                }}
            />
            <SelectField label="Condition Report" name="filters.vehicle.hasCr" options={yesNoOptions} />
            <SelectField label="Vehicle Title" name="filters.vehicle.hasTitle" options={yesNoOptions} />
        </Container>
    )
}

export default VehicleView
